var _style, _circle, _circle2, _circle3, _circle4, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayface(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    circle {\n      fill: #252635;\n    }\n    path {\n      fill: none;\n      stroke: #252635;\n      stroke-width: 12px;\n      stroke-linecap: round;\n    }\n    .face {\n      fill: #f1f1f1;\n    }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 120
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "face",
    cx: 128,
    cy: 128,
    r: 104
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 104,
    r: 12
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 104,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80,150 Q128,190 176,150"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayface);
export default __webpack_public_path__ + "static/media/grayface.326286e6d1cda0c024b6e125c4c84a1b.svg";
export { ForwardRef as ReactComponent };